"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeStep = exports.clear = exports.saveOpeningFailed = exports.saveOpeningValidation = exports.saveOpeningSuccess = exports.saveOpeningRequest = exports.setType = exports.updateFailed = exports.updateValidation = exports.updateSuccess = exports.updateRequest = exports.createFailed = exports.createValidation = exports.createSuccess = exports.createRequest = exports.setBasicInformation = exports.updateProcerement = exports.updatePrintOrderInfo = exports.updateBuyerInfo = exports.updateBasicInfo = exports.init = void 0;
const ActionTypes = require("../../actionTypes/bid/basicInformation");
function init(bid) {
    return {
        type: ActionTypes.INIT,
        payload: {
            bid
        }
    };
}
exports.init = init;
function updateBasicInfo(field, value, hasChanged = true) {
    return {
        type: ActionTypes.UPDATE_BASIC_INFO,
        payload: {
            field,
            value,
            hasChanged
        }
    };
}
exports.updateBasicInfo = updateBasicInfo;
function updateBuyerInfo(field, value, hasChanged = true) {
    return {
        type: ActionTypes.UPDATE_BUYER_INFO,
        payload: {
            field,
            value,
            hasChanged
        }
    };
}
exports.updateBuyerInfo = updateBuyerInfo;
function updatePrintOrderInfo(field, value, hasChanged = true) {
    return {
        type: ActionTypes.UPDATE_PRINT_ORDER_INFO,
        payload: {
            field,
            value,
            hasChanged
        }
    };
}
exports.updatePrintOrderInfo = updatePrintOrderInfo;
function updateProcerement(field, value, hasChanged = true) {
    return {
        type: ActionTypes.UPDATE_PROCEREMENT,
        payload: {
            field,
            value,
            hasChanged
        }
    };
}
exports.updateProcerement = updateProcerement;
function setBasicInformation(bid) {
    return {
        type: ActionTypes.SET_BASIC_INFORMATION,
        payload: {
            bid
        }
    };
}
exports.setBasicInformation = setBasicInformation;
function createRequest(r) {
    return {
        type: ActionTypes.CREATE_REQUEST,
        payload: r
    };
}
exports.createRequest = createRequest;
function createSuccess(bid) {
    return {
        type: ActionTypes.CREATE_SUCCESS,
        payload: bid
    };
}
exports.createSuccess = createSuccess;
function createValidation(payload) {
    return {
        type: ActionTypes.CREATE_VALIDATION,
        payload
    };
}
exports.createValidation = createValidation;
function createFailed(payload) {
    return {
        type: ActionTypes.CREATE_FAILED,
        payload
    };
}
exports.createFailed = createFailed;
function updateRequest(briefcase, bid, body, type, publish) {
    return {
        type: ActionTypes.UPDATE_REQUEST,
        payload: {
            briefcase,
            bid,
            body,
            type,
            publish
        }
    };
}
exports.updateRequest = updateRequest;
function updateSuccess(payload) {
    return {
        type: ActionTypes.UPDATE_SUCCESS,
        payload
    };
}
exports.updateSuccess = updateSuccess;
function updateValidation(payload) {
    return {
        type: ActionTypes.UPDATE_VALIDATION,
        payload
    };
}
exports.updateValidation = updateValidation;
function updateFailed(payload) {
    return {
        type: ActionTypes.UPDATE_FAILED,
        payload
    };
}
exports.updateFailed = updateFailed;
function setType(payload) {
    return {
        type: ActionTypes.SET_TYPE,
        payload
    };
}
exports.setType = setType;
function saveOpeningRequest(briefcase, bid, body) {
    return {
        type: ActionTypes.SAVE_OPENING_EVENT_REQUEST,
        payload: {
            briefcase,
            bid,
            body
        }
    };
}
exports.saveOpeningRequest = saveOpeningRequest;
function saveOpeningSuccess() {
    return {
        type: ActionTypes.SAVE_OPENING_EVENT_SUCCESS
    };
}
exports.saveOpeningSuccess = saveOpeningSuccess;
function saveOpeningValidation(validation) {
    return {
        type: ActionTypes.SAVE_OPENING_EVENT_VALIDATION,
        payload: validation
    };
}
exports.saveOpeningValidation = saveOpeningValidation;
function saveOpeningFailed(payload) {
    return {
        type: ActionTypes.SAVE_OPENING_EVENT_FAILED,
        payload
    };
}
exports.saveOpeningFailed = saveOpeningFailed;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
function changeStep(step) {
    return {
        type: ActionTypes.CHANGE_STEP,
        payload: {
            step
        }
    };
}
exports.changeStep = changeStep;
//# sourceMappingURL=basicInformation.js.map